import { Box, IconButton } from '@mui/material';
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
import { BasketItem } from '../../interfaces/Basket/BasketItem';
import { NumberInput } from '../../components/NumberInput/NumberInput';
import { useIsMobile } from '../../hooks/useIsMobile';

type BasketAmountInputProps = {
  basketItem: BasketItem;
  onChange: (value: number) => void;
};

export const BasketAmountInput = ({
  basketItem,
  onChange,
}: BasketAmountInputProps) => {
  const isMobile = useIsMobile();

  return isMobile ? (
    <Box
      onClick={(ev) => {
        ev.stopPropagation();
        ev.preventDefault();
      }}
      sx={{
        display: 'flex',
        alignItems: 'center',
        border: '1px solid #ddd',
        borderRadius: '8px',
        overflow: 'hidden',
        bgcolor: '#fff5f5',
        width: 'fit-content',
      }}
    >
      <IconButton
        onClick={() => onChange(basketItem.quantity - 1)}
        size='small'
        sx={{
          borderRadius: 0,
          '&:hover': {
            bgcolor: '#ffdcdc',
          },
        }}
      >
        <RemoveIcon fontSize='small' />
      </IconButton>

      <NumberInput value={basketItem.quantity} onChange={onChange} width={80} />

      <IconButton
        onClick={() => onChange(basketItem.quantity + 1)}
        size='small'
        sx={{
          borderRadius: 0,
          '&:hover': {
            bgcolor: '#ffdcdc',
          },
        }}
      >
        <AddIcon fontSize='small' />
      </IconButton>
    </Box>
  ) : (
    <Box
      onClick={(ev) => {
        ev.stopPropagation();
        ev.preventDefault();
      }}
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 0.5,
      }}
    >
      <NumberInput value={basketItem.quantity} onChange={onChange} width={80} />
    </Box>
  );
};
